export default {"src":"/_next/static/media/WhoWeAre_029A.dd6eb8d4.JPG","height":682,"width":1920};